import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import Button from '@atlaskit/button/standard-button';
import AkInlineDialog from '@atlaskit/inline-dialog';
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import { colors } from '@atlaskit/theme';
import { buttonActionTypes } from '../../common/types/button';
import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';
import HtmlContent from '../../controllers/utils/html-content';
var baselineUnit = "var(--ds-space-050, 4px)";
var ContentContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var Image = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var ButtonContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), baselineUnit);
var BodyContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n  color: ", ";\n"])), baselineUnit, baselineUnit, "var(--ds-text, ".concat(colors.N900, ")"));
// eslint-disable-next-line @repo/internal/react/no-class-components
var InlineDialog = /*#__PURE__*/function (_Component) {
  _inherits(InlineDialog, _Component);
  var _super = _createSuper(InlineDialog);
  function InlineDialog() {
    var _this;
    _classCallCheck(this, InlineDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onPrimaryClick", function () {
      _this.props.fireClickEvent('primary');
    });
    _defineProperty(_assertThisInitialized(_this), "onSecondaryClick", function () {
      _this.props.fireClickEvent('secondary');
    });
    return _this;
  }
  _createClass(InlineDialog, [{
    key: "getPrimaryButton",
    value: function getPrimaryButton() {
      var _this$props = this.props,
        primaryAction = _this$props.primaryAction,
        primaryText = _this$props.primaryText;
      return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
  }, {
    key: "getSecondaryButton",
    value: function getSecondaryButton() {
      var _this$props2 = this.props,
        secondaryAction = _this$props2.secondaryAction,
        secondaryText = _this$props2.secondaryText;
      return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
  }, {
    key: "getActionButton",
    value: function getActionButton(appearance, onClick, action, text) {
      var type = action ? action.type : buttonActionTypes.DISMISS;
      switch (type) {
        case buttonActionTypes.LINK:
          {
            var actionData = action.data;
            return /*#__PURE__*/React.createElement(Button, {
              href: actionData.url,
              target: actionData.target,
              appearance: appearance,
              onClick: onClick
            }, text);
          }
        default:
          return /*#__PURE__*/React.createElement(Button, {
            appearance: appearance,
            onClick: onClick
          }, text);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        title = _this$props3.title,
        imageSrc = _this$props3.imageSrc,
        imageAlt = _this$props3.imageAlt,
        body = _this$props3.body,
        position = _this$props3.position,
        order = _this$props3.order,
        secondaryText = _this$props3.secondaryText;
      var messageContent = {
        image: null,
        title: null,
        body: null
      };
      if (title) {
        messageContent.title = /*#__PURE__*/React.createElement("h4", {
          key: "title"
        }, title);
      }
      if (imageSrc) {
        messageContent.image = /*#__PURE__*/React.createElement(Image, {
          key: "img",
          src: imageSrc,
          alt: imageAlt
        });
      }
      messageContent.body = /*#__PURE__*/React.createElement(BodyContainer, {
        key: "body"
      }, /*#__PURE__*/React.createElement(HtmlContent, {
        html: body
      }));
      var orderedContent = order.map(function (c) {
        return messageContent[c];
      });
      var content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ContentContainer, null, orderedContent), /*#__PURE__*/React.createElement(ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
      return /*#__PURE__*/React.createElement(AkInlineDialog, {
        content: content,
        placement: position,
        isOpen: true
      }, children);
    }
  }]);
  return InlineDialog;
}(Component);
_defineProperty(InlineDialog, "defaultProps", {
  children: null,
  order: ['title', 'image', 'body'],
  position: 'bottom left'
});
var InlineDialogWithEvents = withEvents(InlineDialog);
export { InlineDialog, InlineDialogWithEvents };
export default withMessage(InlineDialogWithEvents, 'inlineDialog');